<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import wxapi from '@/utils/wxapi.js'
import { getUserAgent } from '@/utils/openIdLogin'
export default {
  name: 'App',
  data() {
    return {
      timer: null,
      timeNum: 600,
    }
  },
  mounted() {
    this.wechatConfig()
    this.redirectPage()
    // 校验轮询
    this.getLoginState()
  },
  computed: {
    ...mapState('index', ['loginInfo']),
  },
  watch: {
    //   cookie被清理了刷新页面
    $route(to, from) {
      wxapi()

      this.initTitle(to.path)
      let loginInfo = Cookies.get('loginInfo')
        ? JSON.parse(Cookies.get('loginInfo'))
        : ''
      // console.log(loginInfo);
      window.collectEvent('config', {
        user_unique_id: loginInfo ? loginInfo.member_info.id : '', //设置唯一用户ID
      })
      this.setStateItem({
        key: 'loginInfo',
        value: loginInfo,
      })
    },
  },
  methods: {
    ...mapMutations('index', ['setStateItem']),
    ...mapActions('index', ['getSignature', 'requireAutoLogout']),
    // 初始化title
    initTitle(path) {
      if (path == '/billConfirm') {
        document.title = '账单确认页面'
      } else if (path.indexOf('candidateAuth') > -1) {
        document.title = '人才授权'
      } else if (path.indexOf('/talentSquare/register') > -1) {
        document.title = '人才报名'
      } else if (path.indexOf('/talentSquare/detail') > -1) {
        document.title = '候选人详情'
      } else if (path.indexOf('/talentSquare/list') > -1) {
        document.title = '人才广场'
      } else if (path.indexOf('/realNameFace') > -1) {
        document.title = '申请人认证'
      } else {
        document.title = '上禾蛙hewa.cn，更多职位等你来'
      }
    },
    wechatConfig() {
      let params = {
        data: {
          url: window.location.href,
        },
        cb: this.wechatStart,
      }
      this.getSignature(params)
    },
    wechatStart(data) {
      let params = {
        debug: false, //true为开启调试功能，若弹出{"errMsg"："config:ok"}代表配置成功
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
      }
      let obj = Object.assign(data, params)
      wx.config(obj)
    },
    // 屏幕宽度判定调整
    redirectPage() {
      if (
        this.$route.name == 'detail' ||
        this.$route.name == 'recommend' ||
        window.location.href.indexOf('codes=') > -1 ||
        window.location.href.indexOf('/detail?') > -1 ||
        window.location.href.indexOf('/positionDetail?') > -1 ||
        window.location.href.indexOf('/talentSquare') > -1
      ) {
        return
      }
      if (document.body.clientWidth > 750) {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `http://pc-test1.hewa.cn/login.html`
        } else {
          window.location.href = `http://hewa.cn/login.html`
        }
      }
    },
    //---------------------------------------------------
    // 登退逻辑
    getLoginState() {
      this.timer = setInterval(() => {
        this.timeNum--
        //是否过八小时
        if (this.timeNum <= 0) {
          this.timeNum = 600
          // 是否为报名页面
          if (window.location.href.indexOf('talentSquare') > -1) {
            return
          }
          //判断是否已经登陆
          if (this.loginInfo && this.loginInfo.token) {
            let params = {
              //   login_ip: returnCitySN["cip"],
              user_agent: getUserAgent(),
              browser: 2,

              cd: () => {
                if (this.loginInfo.member_info) {
                  Cookies.set(
                    'userPhoneInfo',
                    { mobile: this.loginInfo.member_info.mobile },
                    {
                      expires: 14,
                    }
                  )
                }
                this.toLogin()
              },
            }
            this.requireAutoLogout(params)
          }
        }
      }, 1000)
    },
    toLogin() {
      Cookies.set('loginInfo', '')
      window.location.reload()
    },
  },
}
</script>
<style>
body,
html {
  height: 100%;
}
#app {
  height: 100%;
}
.toast_z {
  z-index: 3000 !important;
}
</style>
